var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_180700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3359 4H2.66927C2.31565 4 1.97651 4.14048 1.72646 4.39052C1.47641 4.64057 1.33594 4.97971 1.33594 5.33333V18.6667C1.33594 19.0203 1.47641 19.3594 1.72646 19.6095C1.97651 19.8595 2.31565 20 2.66927 20H21.3359C21.6896 20 22.0287 19.8595 22.2787 19.6095C22.5288 19.3594 22.6693 19.0203 22.6693 18.6667V5.33333C22.6693 4.97971 22.5288 4.64057 22.2787 4.39052C22.0287 4.14048 21.6896 4 21.3359 4ZM20.3093 18.6667H3.77594L8.4426 13.84L7.4826 12.9133L2.66927 17.8933V6.34667L10.9559 14.5933C11.2058 14.8417 11.5437 14.9811 11.8959 14.9811C12.2482 14.9811 12.5861 14.8417 12.8359 14.5933L21.3359 6.14V17.8067L16.4293 12.9L15.4893 13.84L20.3093 18.6667ZM3.5426 5.33333H20.2559L11.8959 13.6467L3.5426 5.33333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_180700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ac86c74f0daccbdb449f5289b42bb014.svg";
export { ForwardRef as ReactComponent };